const translation = {
  title: 'Audit Logs',
  detail: {
    title: 'Audit Log Detail',
  },
  list: {
    search: 'Search',
    empty_text: 'No Data',
    columns: {
      id: 'ID',
      project: 'Project',
      user: 'User',
      operation: 'Operation',
      resource: 'Resource',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      actions: 'Actions',
    },
    actions: {
      view: 'View',
    },
  },
  form: {
    project: 'Project',
    projectTooltip: 'Project name associated with the operation',
    user: 'User',
    userTooltip: 'User account that performed the operation',
    operation: 'Operation',
    operationTooltip: 'Type of operation performed, such as create, update, delete, etc.',
    resource: 'Resource',
    resourceTooltip: 'Resource type and name involved in the operation',
    queryString: 'Query String',
    queryStringTooltip: 'Query parameters in the request URL',
    body: 'Request Body',
    bodyTooltip: 'Data content carried in the request body (JSON format)',
    result: 'Result',
    resultTooltip: 'Result status of the operation, such as success or failure',
    response: 'Response',
    responseTooltip: 'Response data returned by the server',
    createdAt: 'Created At',
    createdAtTooltip: 'Timestamp when the audit log was recorded',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
}

export default translation
